import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-iframe-slide',
  templateUrl: './iframe-slide.component.html',
  styleUrls: ['./iframe-slide.component.scss'],
})
export class IframeSlideComponent implements OnInit {
  @ViewChild('meuIframe') meuIframe: ElementRef;

  constructor() {}

  ngOnInit(): void {}

  ativarModoTelaCheia() {
    const iframeElement = this.meuIframe.nativeElement;
    if (iframeElement.requestFullscreen) {
      iframeElement.requestFullscreen();
    } else if (iframeElement.mozRequestFullScreen) {
      iframeElement.mozRequestFullScreen();
    } else if (iframeElement.webkitRequestFullscreen) {
      iframeElement.webkitRequestFullscreen();
    }
  }
}
